import { useState } from 'react'
import { Button } from '@/components/ui/button.jsx'
import { Input } from '@/components/ui/input.jsx'
import AxiosInstance from '@/utils/axios.js'
import { toast } from 'sonner'
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from '@/components/ui/card.jsx'


export const extractData = (adData) => {

    const defaultImg = 'https://i.seadn.io/gae/OGpebYaykwlc8Tbk-oGxtxuv8HysLYKqw-FurtYql2UBd_q_-ENAwDY82PkbNB68aTkCINn6tOhpA8pF5SAewC2auZ_44Q77PcOo870?auto=format&dpr=1&w=1000'

    let adBody = adData.body ? adData.body : ''
    let adImage = adData.originalImageUrl ? adData.originalImageUrl : (adData.videoPreviewImageUrl ?? defaultImg)
    let adVideo = adData.videoSdUrl ? adData.videoSdUrl : ''
    let ctaText = adData.ctaText ? adData.ctaText : 'Shop Now'
    let adBottomText = adData.title ? adData.title : ''
    // let linkUrl = adData.linkUrl ? stripURL(adData.linkUrl) : ''
    let originalLinkUrl = adData.linkUrl

    const innerCard = adData.adCards?.[0]
    if (innerCard) {
        adBody = innerCard.body ? innerCard.body : ''
        adImage = innerCard.originalImageUrl ? innerCard.originalImageUrl : (innerCard.videoPreviewImageUrl ?? defaultImg)
        adVideo = innerCard.videoSdUrl ? innerCard.videoSdUrl : ''
        ctaText = innerCard.ctaText ? innerCard.ctaText : 'Shop Now'
        adBottomText = innerCard.title ? innerCard.title : ''
        // linkUrl = innerCard.linkUrl ? stripURL(innerCard.linkUrl) : ''
        originalLinkUrl = innerCard.linkUrl
    }

    return { adBody, adImage, adVideo, ctaText, adBottomText, originalLinkUrl }
}

export default function EmbeddingsSearchPage() {
    const [searchQuery, setSearchQuery] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [results, setResults] = useState(null)

    const handleSearch = async () => {
        if (!searchQuery.trim()) {
            toast.error('Please enter a search query')
            return
        }

        setIsLoading(true)
        setResults(null)

        try {
            const response = await AxiosInstance.get(`/visual-engine/test-embeddings?search=${encodeURIComponent(searchQuery.trim())}`)
            // Ensure response.data is an array
            const resultsData = Array.isArray(response.data) ? response.data : [response.data]
            setResults(resultsData)
            toast.success('Search completed successfully')
        } catch (error) {
            console.error('Search error:', error)
            toast.error('Failed to perform search. Please try again.')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="container mx-auto py-8 px-4">
            <Card>
                <CardHeader>
                    <CardTitle>Embeddings Search</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="flex flex-col gap-4">
                        <div className="flex items-center gap-4">
                            <div className="flex-1">
                                <Input
                                    placeholder="Enter your search query"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSearch()
                                        }
                                    }}
                                    disabled={isLoading}
                                />
                            </div>
                            <Button
                                onClick={handleSearch}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Searching...' : 'Run'}
                            </Button>
                        </div>

                        {isLoading && (
                            <div className="flex justify-center py-8">
                                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
                            </div>
                        )}

                        {results && (
                            <div className="mt-4">
                                <h3 className="text-lg font-medium mb-4">Search Results</h3>

                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                    {results.map((result, index) => {
                                        console.log(result._id)
                                        const { adBody, adImage, adVideo, ctaText, adBottomText, originalLinkUrl } = extractData(result)

                                        return (
                                            <Card key={index} className="overflow-hidden flex flex-col h-full">
                                                <div className="relative aspect-video overflow-hidden bg-gray-100">
                                                    {adVideo ? (
                                                        <video
                                                            src={adVideo}
                                                            className="w-full h-full object-cover"
                                                            controls
                                                            poster={adImage}
                                                        />
                                                    ) : (
                                                        <img
                                                            src={adImage}
                                                            alt={adBottomText || 'Ad image'}
                                                            className="w-full h-full object-cover"
                                                        />
                                                    )}
                                                </div>

                                                <CardContent className="flex-grow py-4">
                                                    {adBody && (
                                                        <p className="text-sm mb-2">{adBody}</p>
                                                    )}

                                                    {adBottomText && (
                                                        <h3 className="font-medium">{adBottomText}</h3>
                                                    )}
                                                </CardContent>

                                                <CardFooter className="pt-0 flex justify-between items-center">
                                                    {ctaText && (
                                                        <Button variant="outline" size="sm">{ctaText}</Button>
                                                    )}

                                                    {originalLinkUrl && (
                                                        <a
                                                            href={originalLinkUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-xs text-gray-500 hover:underline truncate max-w-[200px]"
                                                        >
                                                            {new URL(originalLinkUrl).hostname}
                                                        </a>
                                                    )}
                                                </CardFooter>
                                            </Card>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}
